(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-video"] && !Shopify.designMode) return;
  try {
    

     document.addEventListener("DOMContentLoaded", function () {
        const playBtn = document.getElementById("playbt");
        if (playBtn) {
            playBtn.addEventListener("click", playVideo);
        }
    });


    function playVideo() {
        var video = document.getElementById("home-mobVid");
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    }

  

  } catch(e) { console.error(e); }
})();
})();
